export const phrasesLocalStorageKey = 'ft-phrases-v1.0';
export const aspectsLocalStorageKey = 'ft-aspects-v2.0';
